




import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
	componentId: 'C003'
})
export default class RichText extends Vue {
	@Prop(String)
	protected readonly copy!: string;

	@Prop({ type: String, default: 'copy-a1' })
	protected readonly fontStyle!: string;

	@Prop(String)
	protected readonly variant?: string;
}
